export const ACCESSOR_SIZE = 52;
export const OPTIONS_SIZE = 50;

const getColumnSize = (percent: number, totalWidth?: number) => {
  if (!totalWidth) {
    return undefined;
  }
  return (totalWidth - ACCESSOR_SIZE - OPTIONS_SIZE) * percent;
};

export const getColumns = (totalWidth?: number) => [
  {
    accessorKey: 'accessory',
    size: ACCESSOR_SIZE,
    accessory: true,
  },
  {
    accessorKey: 'title',
    header: 'Title',
    minSize: 40,
    sx: { pl: 0 },
    size: getColumnSize(0.25, totalWidth),
    enableResizing: true,
  },
  {
    accessorKey: 'modified',
    header: 'Last Modified',
    size: getColumnSize(0.25, totalWidth),
    minSize: 112,
    enableResizing: true,
  },
  {
    accessorKey: 'created',
    header: 'Created',
    size: getColumnSize(0.25, totalWidth),
    minSize: 72,
    enableResizing: true,
  },
  {
    accessorKey: 'files',
    header: 'Audio files',
    size: getColumnSize(0.25, totalWidth),
  },
  {
    accessorKey: 'gap',
    size: 0,
  },
  {
    accessorKey: 'options',
    size: OPTIONS_SIZE,
    isOptions: true,
  },
];
